import { IconButton, TableCell, TableRow, TableRowProps, useMediaQuery, useTheme } from '@mui/material'
import { EthAccountButton } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { MdRefresh } from 'react-icons/md'

import { useAuction } from '../../../Contexts'
import Actions from '../../Actions'
import EndTimer from '../../EndTimer'
import GeotokenIdentification from '../../GeotokenIdentification'
import { TokenPrice } from '../../TokenPrice'

export interface AuctionTableRowProps extends TableRowProps {
  quadkey?: Quadkey
}

export const AuctionTableRow: React.FC<AuctionTableRowProps> = ({ quadkey, ...props }) => {
  const { auction, refresh } = useAuction(quadkey)
  const page = auction?.isMinted() ? 'geotoken' : 'auction'
  const theme = useTheme()
  const largeUp = useMediaQuery(theme.breakpoints.up('lg'))
  const mediumUp = useMediaQuery(theme.breakpoints.up('md'))
  const smallUp = useMediaQuery(theme.breakpoints.up('sm'))

  const bidder = auction?.dynamic?.bidder

  const onRefresh = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    refresh?.()
  }

  return (
    <TableRow {...props}>
      <TableCell align="left">
        <GeotokenIdentification fullWidth size="small" cropMap={false} icon={false} page={page} quadkey={quadkey} worldMap={false} />
      </TableCell>
      {largeUp ? (
        <TableCell align="center">
          <Actions quadkey={quadkey} size="small" />
        </TableCell>
      ) : null}
      {mediumUp ? (
        <TableCell width="100%" align="center">
          <EthAccountButton
            addressLength={largeUp ? 'long' : 'short'}
            fullWidth
            size="small"
            variant="outlined"
            address={bidder}
            icon
            iconSize={16}
          />
        </TableCell>
      ) : null}
      {smallUp ? (
        <TableCell align="center">
          <EndTimer quadkey={quadkey} />
        </TableCell>
      ) : null}
      <TableCell align="center">
        <TokenPrice fullWidth size="small" logo quadkey={quadkey} />
      </TableCell>
      <TableCell align="center">
        <IconButton size="small" onClick={onRefresh}>
          <MdRefresh />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
